import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import _nth from 'lodash/nth';
import _get from 'lodash/get';
import _throttle from 'lodash/throttle';
import _defer from 'lodash/defer';
import _isEqual from 'lodash/isEqual';
import _find from 'lodash/find';
import Input from '../../components/Input/Input';
import Icon from '../../components/Icon/Icon';
import config from './TypeaheadInput.config';
import * as styles from './TypeaheadInput.css';
import TypeaheadSuggestionBoxLazy from './TypeaheadSuggesionBoxLazy';

const cx = classNames.bind(styles);

class TypeaheadInput extends Component {
    static propTypes = {
        datasource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        header: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        placeholder: PropTypes.string,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        onSubmit: PropTypes.func,
        onSelect: PropTypes.func,
        onMouseDown: PropTypes.func,
        onMouseUp: PropTypes.func,
        onKeyDown: PropTypes.func,
        onReset: PropTypes.func,
        inputText: PropTypes.string,
        isFocused: PropTypes.bool,
        automationId: PropTypes.string,
        type: PropTypes.string,
        disableAutoComplete: PropTypes.bool,
        delay: PropTypes.number,
        presetText: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
        typeaheadEnabled: PropTypes.bool,
        productDisplayEnabled: PropTypes.bool,
    };

    static defaultProps = {
        datasource: [],
        data: [],
        header: null,
        placeholder: 'Search products...',
        onChange: null,
        onFocus: null,
        onBlur: null,
        onSelect: null,
        onSubmit: null,
        onMouseDown: null,
        onMouseUp: null,
        onKeyDown: null,
        onReset: null,
        inputText: '',
        isFocused: true,
        automationId: '',
        type: 'search',
        showFeatureResult: false,
        disableAutoComplete: false,
        delay: 1000,
        presetText: '',
        typeaheadEnabled: false,
        productDisplayEnabled: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            productList: [],
            currentSelection: 0,
            currentTerm: '',
            selectedMouseOverItem: '',
            eventAction: false,
            value: this.props.inputText || '',
        };

        this.onMouseOver = this.onMouseOver.bind(this);
    }

    componentWillMount() {
        if (!__SERVER__) {
            this.initialLoad = true;
            this.throttledOnChange = this.props.onChange && _throttle(this.props.onChange, this.props.delay);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.initialLoad) {
            this.initialLoad = false;
            this.setState({
                value: nextProps.presetText,
            });
        }
    }

    shouldComponentUpdate = (nextProps) => {
        const shouldRender = this.props.inputText !== nextProps.inputText
            || nextProps.isFocused
            || this.props.isFocused !== nextProps.isFocused
            || !_isEqual(_get(nextProps, 'nextProps.datasource[0].products', []), this.state.productList);
        return shouldRender;
    }

    componentDidUpdate(previousProps) {
        // This initial load tracks if we have to use the initial input text value
        // sents as props
        if (this.initialLoad) {
            this.initialLoad = false;
        }

        /* istanbul ignore if */
        if (previousProps.datasource !== this.props.datasource) {
            this.setProductList();
        }
    }

    onSelect = (event) => {
        let currentElemetOrPrevElement = event.target;
        /* istanbul ignore if */
        if (currentElemetOrPrevElement.tagName === 'STRONG') {
            currentElemetOrPrevElement = event.target.parentElement;
        } else if (!currentElemetOrPrevElement.dataset.currentitem) {
            currentElemetOrPrevElement = event.target.parentElement.getElementsByTagName('span')[0];
        }

        const newValue = currentElemetOrPrevElement.dataset.currentitem;

        const searchResult = {
            term: newValue,
            dept: null,
            position: currentElemetOrPrevElement.dataset.position,
            link: currentElemetOrPrevElement.dataset.link,
            inputText: this.props.inputText,
        };

        if (newValue.includes(' in ')) {
            if (this.props.header === null) {
                searchResult.term = currentElemetOrPrevElement.dataset.prevdept || this.props.inputText;
                searchResult.dept = newValue;
            } else {
                searchResult.term = newValue;
            }
        }

        this.setState({ value: searchResult.term });

        if (this.props.onBlur) {
            this.props.onBlur();
        }

        if (this.props.onSelect) {
            this.props.onSelect(searchResult);
        }
    };

    onMouseDown = () => {
        if (this.props.onMouseDown) {
            this.props.onMouseDown();
        }
    };

    onMouseUp = () => {
        if (this.props.onMouseUp) {
            this.props.onMouseUp();
        }
    };

    onFocus = () => {
        this.setState({
            eventAction: false,
        });
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };

    onBlur = () => {
        this.setState({
            eventAction: false,
        });
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    onSubmit = (event) => {
        const { selectedMouseOverItem, value } = this.state;
        const inputText = (selectedMouseOverItem && selectedMouseOverItem !== value) ?
            selectedMouseOverItem :
            value || this.props.inputText;
        if (!inputText) {
            event && event.preventDefault();
            return;
        }

        let searchResult;
        if (value !== '') {
            searchResult = selectedMouseOverItem !== '' ? this.predectiveSearch(inputText) : this.nonPredectiveSearch(inputText);
        } else {
            searchResult = this.predectiveSearch(inputText);
        }

        if (this.props.onSubmit) {
            this.props.onSubmit(searchResult);
        }
        event.preventDefault();
    };

    onMouseOver = (event) => {
        let currentElemetOrPrevElement = event.target;
        /* istanbul ignore else */
        if (!currentElemetOrPrevElement.dataset.currentitem) {
            currentElemetOrPrevElement = event.target.parentElement.getElementsByTagName('span')[0];
        }
        const { position, type, index, categoryposition } = currentElemetOrPrevElement.dataset;

        // Not to set state if currentSelection and index are same
        /* istanbul ignore else */
        if (this.state.currentSelection !== index) {
            this.setState({
                currentSelection: parseInt(index, 0),
                eventAction: true,
            });
            this.setProductList(position, type, categoryposition);
        }
    };

    onKeyDown = (eventArgs) => {
        eventArgs && eventArgs.persist();
        this.onKeyDownHandler(eventArgs);
    };

    onKeyDownHandler = eventArgs => _defer((event) => {
        event.persist();
        const { currentSelection } = this.state;
        const { data, header } = this.props;
        let selection = currentSelection;

        if (!this.state.eventAction && header && selection === 0) {
            selection = -1;
        }

        switch (event.keyCode) {
            case 38: // up
                event.preventDefault();
                // Recent search - initial data will be -1, precedictive search will be 0
                if (selection === -1 || selection === 0) return;
                selection -= 1;
                break;
            case 40: // down
                if (selection === data.length - 1) return;
                event.preventDefault();
                selection += 1;
                break;
            default:
                return;
        }

        const item = _nth(data, selection);
        if (!item) return;
        const { position, type, categoryPosition, value, parentItem } = item;

        this.setState({
            currentSelection: parseInt(selection, 0),
            eventAction: true,
        });
        this.setProductList(position, type, categoryPosition);
        if (this.props.onKeyDown) {
            let inputValue = value;
            if (parentItem) {
                inputValue = `${parentItem}${value}`;
            }
            this.props.onKeyDown(inputValue);
            this.setState({
                selectedMouseOverItem: inputValue,
            });
        }
    }, eventArgs);

    onChange = (value) => {
        // event.persist();
        // To reset the selection and make default first one to be selected
        this.setState({
            currentSelection: parseInt(0, 0),
            selectedMouseOverItem: '',
            eventAction: false,
            value,
        });
        this.setProductList(); // To make default first one to be selected

        if (this.throttledOnChange) {
            this.throttledOnChange(value);
        }
    };

    onReset = () => {
        if (this.props.onReset) {
            this.props.onReset();
        }
        this.setState({ value: '' });
        if (this.textInput) this.textInput.focus();
    };

    setProductList = (position = 1, type = 'term', categoryposition = 1) => {
        const { datasource, header } = this.props;

        if (position && datasource && datasource.length > 0) {
            if (type === 'term') {
                const i = header ? 0 : 1;
                const category = _nth(datasource, position - i);
                if (category) {
                    this.setState({ productList: category.products || [], currentTerm: category.term });
                }
            } else {
                const category = _nth(datasource, categoryposition - 1);
                const department = _nth(category.depts, position - 1);
                this.setState({
                    productList: department.products,
                    currentTerm: `${category.term} in ${department.name}`,
                });
            }
        }
    }

    predectiveSearch = (inputText) => {
        const splitSelectedValue = inputText.split(' in ')[0];
        const splitSelectedDept = inputText.split(' in ')[1];
        const { datasource } = this.props;
        const findProduct = _find(datasource, product => (
            product.term === splitSelectedValue),
        );
        const findDept = findProduct && findProduct.depts && _find(findProduct.depts, getDept => (
            getDept.name === splitSelectedDept),
        );
        return {
            term: inputText,
            link: findDept ? (findDept.href || findDept.departmentURL) : findProduct && findProduct.url,
        };
    }

    nonPredectiveSearch = inputText => ({
        term: inputText,
    });

    renderInput() {
        const { type, automationId, placeholder, disableAutoComplete } = this.props;
        return (
            <form action="/s/search" className={styles.typeaheadFocusInputContent} onSubmit={this.onSubmit}>
                <Input
                    id="searchInputId"
                    refCallBack={(input) => { this.textInput = input; }}
                    name="Ntt"
                    type={type}
                    value={this.state.value}
                    automationId={automationId}
                    theme={styles.inputBox}
                    placeholder={placeholder}
                    onChange={this.onChange}
                    disableAutoComplete={disableAutoComplete}
                />
            </form>
        );
    }

    renderResetIcon() {
        if ((this.props.inputText.length > 0) && this.props.isFocused) {
            return (
                <button
                    id="TypeaheadInputRestBtn" className={styles.resetIconBlock} onClick={this.onReset}
                    type="button">
                    <Icon iconType="svg" width="20" height="20" viewBox="0 0 25 25">
                        {config.svgResetIconComponent}
                    </Icon>
                </button>
            );
        }
        return '';
    }

    render() {
        const {
            productList,
            currentSelection,
            currentTerm,
            selectedMouseOverItem,
            eventAction,
            value,
        } = this.state;
        const typeaheadInputField = this.props.isFocused ? cx('typeaheadInputFieldFocused', 'inputFieldBlock') : cx('typeaheadInputFieldBlurred', 'inputFieldBlock');
        return (
            // eslint-disable-next-line
            <div
                className={styles.typeaheadInputContainer}
                id="typeaheadInputContainer"
                onMouseDown={this.onMouseDown}
                onBlur={this.onBlur}
                onMouseUp={this.onMouseUp}
                onFocus={this.onFocus}
                onKeyDown={this.onKeyDown}>
                <div className={typeaheadInputField}>
                    <button title="search" onClick={this.onSubmit} type="button" className={styles.searchIconBlock}>
                        <Icon iconType="svg" width="40px" height="40px" viewBox="-10 -10 40 40" pathClassName={styles.headerSearchIcon}>
                            {config.svgSearchIconComponent}
                        </Icon>
                    </button>
                    {this.renderInput()}
                    {this.renderResetIcon()}
                </div>

                {this.props.typeaheadEnabled &&
                <TypeaheadSuggestionBoxLazy
                    {...this.props}
                    productList={productList}
                    currentSelection={currentSelection}
                    currentTerm={currentTerm}
                    selectedMouseOverItem={selectedMouseOverItem}
                    eventAction={eventAction}
                    value={value}
                    onMouseOver={this.onMouseOver}
                    onSelect={this.onSelect}
                    productDisplayEnabled={this.props.productDisplayEnabled}
                />
                }
            </div>
        );
    }
}

export default TypeaheadInput;
